import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Ceu } from '../_models/ceu';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CeuService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getCeu(resourceId: string, versionId?: string, energyId?: string) {
    let params = new HttpParams();
    params = versionId ? params.set('versionId', versionId) : params;
    params = energyId ? params.set('energyId', energyId) : params;
    params = params.set('resourceId', resourceId);
    return this.http.get<Ceu>(`${environment.apiUrl}/Ceu`, {
      params: params,
      headers: this.authService.headers
    });
  }
}
